const ViewIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_321_1311)">
        <rect
          x="2"
          y="1"
          width="32"
          height="32"
          rx="4"
          fill="none"
          shapeRendering="crispEdges"
        />
        <path
          d="M18 21.5C19.25 21.5 20.3125 21.0625 21.1875 20.1875C22.0625 19.3125 22.5 18.25 22.5 17C22.5 15.75 22.0625 14.6875 21.1875 13.8125C20.3125 12.9375 19.25 12.5 18 12.5C16.75 12.5 15.6875 12.9375 14.8125 13.8125C13.9375 14.6875 13.5 15.75 13.5 17C13.5 18.25 13.9375 19.3125 14.8125 20.1875C15.6875 21.0625 16.75 21.5 18 21.5V21.5M18 19.7C17.25 19.7 16.6125 19.4375 16.0875 18.9125C15.5625 18.3875 15.3 17.75 15.3 17C15.3 16.25 15.5625 15.6125 16.0875 15.0875C16.6125 14.5625 17.25 14.3 18 14.3C18.75 14.3 19.3875 14.5625 19.9125 15.0875C20.4375 15.6125 20.7 16.25 20.7 17C20.7 17.75 20.4375 18.3875 19.9125 18.9125C19.3875 19.4375 18.75 19.7 18 19.7V19.7M18 24.5C15.5667 24.5 13.35 23.8208 11.35 22.4625C9.35 21.1042 7.9 19.2833 7 17C7.9 14.7167 9.35 12.8958 11.35 11.5375C13.35 10.1792 15.5667 9.5 18 9.5C20.4333 9.5 22.65 10.1792 24.65 11.5375C26.65 12.8958 28.1 14.7167 29 17C28.1 19.2833 26.65 21.1042 24.65 22.4625C22.65 23.8208 20.4333 24.5 18 24.5V24.5M18 17V17V17V17V17V17V17V17V17V17M18 22.5C19.8833 22.5 21.6125 22.0042 23.1875 21.0125C24.7625 20.0208 25.9667 18.6833 26.8 17C25.9667 15.3167 24.7625 13.9792 23.1875 12.9875C21.6125 11.9958 19.8833 11.5 18 11.5C16.1167 11.5 14.3875 11.9958 12.8125 12.9875C11.2375 13.9792 10.0333 15.3167 9.2 17C10.0333 18.6833 11.2375 20.0208 12.8125 21.0125C14.3875 22.0042 16.1167 22.5 18 22.5V22.5"
          fill="#0F1560"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_321_1311"
          x="0"
          y="0"
          width="36"
          height="36"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_321_1311"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_321_1311"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default ViewIcon;
